import { applyRequired, createResult, fail, ok, runFieldMap, toText } from "./shared.js";
import { runValidators, validateChars, validateMaxLength, validateOneOf } from "./validators.js";

const noControlCharsRegex = /^[^\p{C}]*$/u;

export const mailMeUnsubscribeActions = Object.freeze({
    disableForever:"disableForever",
    muteMonth:"muteMonth"
});

export const mailMeUnsubscribeActionList = Object.freeze(Object.values(mailMeUnsubscribeActions));

export const mailMeUnsubscribeCategories = Object.freeze([
    "mailMeBackoffice",
    "mailMeGameNews",
    "mailMeMarketing"
]);

export const mailMeUnsubscribeDefaultReason = "no_reason";

export const mailMeUnsubscribeReasons = Object.freeze([
    { value:mailMeUnsubscribeDefaultReason, label:"Nechci uvádět důvod" },
    { value:"too_many", label:"E-mailů chodí příliš mnoho" },
    { value:"not_relevant", label:"Obsah pro mě není relevantní" },
    { value:"broken_email", label:"E-maily se špatně čtou nebo nefungují odkazy" },
    { value:"using_without_email", label:"Nechci e-maily, ale Blimp dál využívám" },
    { value:"leaving_blimp", label:"Blimp už nechci využívat" },
    { value:"other", label:"Jiný důvod" }
]);

export const mailMeUnsubscribeReasonList = Object.freeze(mailMeUnsubscribeReasons.map(reason=>reason.value));

export const mailMeUnsubscribeFormFields = Object.freeze([
    "payloadToken",
    "action",
    "reason",
    "message"
]);

const requiredFields = Object.freeze(["payloadToken", "action", "reason"]);

const validateToken = raw=>ok(toText(raw, { max:2048 }));

const validateAction = raw=>{
    const value = toText(raw, { max:32 });
    const error = validateOneOf(value, mailMeUnsubscribeActionList);
    return error ? fail(value, error) : ok(value);
};

const validateReason = raw=>{
    const value = toText(raw, { max:64 });
    const error = validateOneOf(value, mailMeUnsubscribeReasonList);
    return error ? fail(value, error) : ok(value);
};

const validateMessage = raw=>{
    const value = toText(raw, { max:2000 });
    const error = runValidators(value, [
        item=>validateMaxLength(item, 1000),
        item=>validateChars(item, noControlCharsRegex, { chars:"no_control" })
    ]);
    return error ? fail(value, error) : ok(value);
};

const validators = Object.freeze({
    payloadToken:validateToken,
    action:validateAction,
    reason:validateReason,
    message:validateMessage
});

export const validateMailMeUnsubscribeForm = (input={})=>{
    const { values, fieldErrors } = runFieldMap(input, mailMeUnsubscribeFormFields, validators);
    applyRequired(values, fieldErrors, requiredFields);
    return createResult(values, fieldErrors, []);
};
